import React, { useEffect, useState } from "react";
import ApiServices from "../../services/apiServices";
import "./index.css";
import storage from "../../services/storage";
import { toast } from "react-toastify";
import { useLoad } from "../../context/Load";
import ForcaSenha from "../../Components/ForcaSenha";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router";
import Tabela from "../../Components/Tabela";
import { Box } from "@mui/material";
import { FaRegEdit } from "react-icons/fa";
import { BsFiletypeXlsx } from "react-icons/bs";
import modeloRelatorio from "../../assets/Doc/ModeloImportaçãoVendas.xlsx";
import moment from "moment";
export default function Apuracao() {
  const [listarTiposApuracao, setListarTiposApuracao] = useState([
    { nome: "Gerente", id: 1 },
    { nome: "Vendedor", id: 2 },
  ]);
  const [listarApuracao, setListarApuracao] = useState([]);
  const [apuracao, setApuracao] = useState({
    apuracao: "",
    tipoApuracao: "1",
  });

  const [filtroColuna, setFiltroColuna] = useState([]);
  const [idCampanha, setIdCampanha] = useState("");
  const [pesquisar, setPesquisar] = useState("");
  const [trava, setTrava] = useState(false);
  const navigate = useNavigate();
  const { load, setLoad } = useLoad();
  const [paginacao, setPaginacao] = useState({
    pageIndex: 1,
    pageSize: 10,
  });

  const colunas = [
    {
      accessorKey: "data",
      header: "Data / Hora",
      Cell: ({ row }) =>
        row.original.data
          ? moment(row.original.data).format("DD/MM/YYYY HH:mm:ss")
          : "",
      muiTableHeadCellProps: { align: "left" },
      muiTableBodyCellProps: { align: "left" },
    },
    {
      accessorKey: "participanteNome",
      header: "Usuário",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      accessorKey: "nomeArquivo",
      header: "Nome do Arquivo",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      accessorKey: "total",
      header: "Total",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      accessorKey: "sucesso",
      header: "Sucesso",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },

    {
      id: "mrt-custom-actions",
      header: "Ação",
      accessor: (row) => row,
      Cell: ({ row }) => (
        <>
          <div className="d-flex justify-content-end">
            {row.original.status.apuracaoStatusId != "processando" ? (
              <button
                className="btn btn-outline-secondary mx-1"
                style={{ minWidth: 100 }}
                disabled={trava}
                onClick={() => {
                  setTrava(true);
                  fnBotaoExportar(row.original.importacaoId);
                }}
              >
                Exportar
              </button>
            ) : (
              <div
                className="mx-1"
                style={{ width: 100, height: 40, minWidth: 100 }}
              >
                {" "}
                ⁫ 
              </div>
            )}
          </div>
        </>
      ),
      muiTableHeadCellProps: { align: "right" },
      muiTableBodyCellProps: { align: "right" },
    },
  ];

  async function fnBotaoExportar(id) {
    setLoad(true);
    var url = ``;
    var nomeArquivo = "";
    if (apuracao.tipoApuracao == "1") {
      url = `importacao/validador-apuracao/gerente/resultado?ImportacaoLogId=${id}`;
      nomeArquivo = "apuracao-gerente ";
    } else {
      url = `importacao/validador-apuracao/vendedor/resultado?ImportacaoLogId=${id}`;
      nomeArquivo = "apuracao-vendedor";
    }
    try {
      let response = await ApiServices.apiDownloadXlsxGET(url, nomeArquivo);
      if (response.statusCode == 200) {
        fnListarApuracoes();
      } else {
        toast.error(response.message);
      }
      setTrava(false);
    } catch (err) {
      console.error("err", err);
      setTrava(false);
    } finally {
      setLoad(false);
    }
  }
  async function fnListarApuracoes() {
    if (idCampanha) {
      setLoad(true);

      const parametros = {
        q: pesquisar || "",
        page: paginacao.pageIndex || "1",
        pageSize: paginacao.pageSize || "",
        campanhaId: idCampanha || "",
      };

      try {
        const queryString = new URLSearchParams(parametros).toString();
        let response = await ApiServices.apiGet("apuracao?" + queryString);
        response.data.items.forEach((element) => {
          element.data = moment(element.data).format("DD/MM/YYYY HH:mm:ss");
        });
        if (response.statusCode == 200) {
        } else {
          toast.error(response.message);
        }
      } catch (err) {
        console.error("err", err);
      } finally {
        setLoad(false);
      }
    } else {
      setListarApuracao([]);
    }
  }
  async function fnListarApuracao() {
    setLoad(true);
    try {
      var url = "";
      if (apuracao.tipoApuracao == "1") {
        url = "importacao/gerente";
      } else {
        url = "importacao/vendedor";
      }
      let response = await ApiServices.apiGet(url);

      setListarApuracao(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    fnListarApuracao();
  }, [apuracao.tipoApuracao]);

  return (
    <>
      <div className="row">
        <span className="tituloPagina">VALIDADOR DE APURAÇÃO</span>
        <div className="row d-flex align-items-end ">
          <div className="col-md-3 mt-3">
            <form autoComplete="off">
              <label>Campanha</label>

              <select
                className="form-select"
                value={apuracao.tipoApuracao}
                onChange={(e) => {
                  setApuracao((prev) => ({
                    ...prev,
                    tipoApuracao: e.target.value,
                  }));
                }}
              >
                <option value="">Selecione</option>
                {listarTiposApuracao?.map((e, i) => (
                  <option key={i} value={e.id}>
                    {e.nome}
                  </option>
                ))}
              </select>
            </form>
          </div>
        </div>
        <div className="subTituloPagina">Apurações realizadas</div>
      </div>

      <Tabela
        colunas={colunas}
        dados={listarApuracao || []}
        paginacaoPelaApi={false}
        totalLinhas={listarApuracao.length || 0}
        setPaginacao={setPaginacao}
        paginacao={paginacao}
        setPesquisar={(e) => {
          setPesquisar(e);
        }}
        filtroColuna={filtroColuna}
        setFiltroColuna={setFiltroColuna}
        buscaColunas={false}
      />
    </>
  );
}
